import { render, staticRenderFns } from "./CollectLogLists.vue?vue&type=template&id=5bfcfd84&"
import script from "./CollectLogLists.vue?vue&type=script&lang=js&"
export * from "./CollectLogLists.vue?vue&type=script&lang=js&"
import style0 from "./CollectLogLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports